import { TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";

const fmt = (v) => v == null ? "—" : "$" + v.toLocaleString();

export default function CashForesight({ data, loading }) {
  if (loading) return <Card className="animate-pulse h-80" />;
  if (!data) return null;

  const { summary, buckets } = data;
  const bks = [
    { k: "past_due", l: "Past Due", d: true },
    { k: "next_30_days", l: "30 Days" },
    { k: "next_60_days", l: "60 Days" },
    { k: "next_90_days", l: "90 Days" },
    { k: "beyond_90_days", l: "90+ Days" }
  ];

  return (
    <Card data-testid="cash-foresight-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2" style={{ fontFamily: 'var(--font-sans)' }}>
          <TrendingUp className="w-5 h-5" />
          Cash Foresight
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-4 mb-6">
          <div className="text-center p-3 bg-muted/30 rounded-lg">
            <p className="text-xs text-muted-foreground">Expected</p>
            <p className="text-lg font-semibold">{fmt(summary.total_expected)}</p>
          </div>
          <div className="text-center p-3 bg-muted/30 rounded-lg">
            <p className="text-xs text-muted-foreground">Weighted</p>
            <p className="text-lg font-semibold text-green-600">{fmt(summary.total_weighted)}</p>
          </div>
          <div className="text-center p-3 bg-muted/30 rounded-lg">
            <p className="text-xs text-muted-foreground">Risk Gap</p>
            <p className="text-lg font-semibold text-amber-500">{fmt(summary.confidence_gap)}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
          {bks.map(b => {
            const bk = buckets[b.k];
            return (
              <div key={b.k} className={`rounded-lg border p-3 min-w-0 ${b.d && bk.expected > 0 ? "border-red-500/50" : ""}`}>
                <p className="text-xs text-muted-foreground mb-1 truncate">{b.l}</p>
                <p className="text-sm font-semibold truncate">{fmt(bk.expected)}</p>
                {bk.count > 0 && <Badge variant="secondary" className="text-xs mt-1">{bk.count}</Badge>}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
